import { Component } from '@angular/core';
import { AuthService } from './shared/services/auth-service';
import { MatDialog } from '@angular/material/dialog';
import { ClosedReviewMessageComponent } from 'src/app/shared/components/closed-review-message/closed-review-message.component';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  loading: boolean = false;
  userSub: string | undefined
  constructor(
    private _authService: AuthService,
    private dialog: MatDialog,

  ){
    this._authService.getSettings('exclusive_user_use').subscribe(settings=>{
      if(settings.response.active === true)
      {
        this.userSub = this._authService.getSub()
        if(settings.response.allowed_users.includes(this.userSub))
        {
          // console.log("User approved")
        }
        else{
          this.loading = true;
          const dialogRef = this.dialog.open(ClosedReviewMessageComponent, {
            data: {
              title: settings.response.display_text
            },
            disableClose: true,
          });
        }
      }
    })
  }
  title = 'proposal-ingestion-tool';
}
